import typo from '../flightBriefTypography.module.css';
import styles from './PassengerLine.module.css';

/**
 * A single passengers row: a category icon followed by a comma-separated list
 * of names.
 * @param {object} props
 * @param {React.ReactNode} [props.icon] - Category icon slot.
 * @param {React.ReactNode} props.children - Passenger names.
 * @param {string} [props.className] - Extra class names for layout overrides.
 * @returns {JSX.Element}
 */
function PassengerLine({ icon = null, children, className = '' }) {
  return (
    <div className={`${styles.line} ${className}`}>
      {icon ? <span className={styles.icon}>{icon}</span> : null}
      <p className={`${styles.names} ${typo['p1-light']}`}>{children}</p>
    </div>
  );
}

export default PassengerLine;
